module.exports = __webpack_public_path__ + "img/banner-inscrevase.cf9d2cd4.png";